import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-trigger-reihenfolge-setzen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichTriggerReihenfolgeSetzenEffects {

    BereichTriggerReihenfolgeSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_TRIGGER_REIHENFOLGE_SETZEN),
        mergeMap((x: ac.PostBereichTriggerReihenfolgeSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichTriggerReihenfolgeSetzen(x.bereichTriggerReihenfolgeRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichTriggerReihenfolgeSetzenErfolgreichAction(result, x.bereichTriggerReihenfolgeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichTriggerReihenfolgeSetzenFehlerAction(error, x.bereichTriggerReihenfolgeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
